import Vue from 'vue';
import 'es6-promise/auto';
import Vuex from "vuex";


Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    activeContentDIV: ''
  },
  actions: {},
  mutations: {
    setActiveContentDIV(state, data){
      state.activeContentDIV = data;
    }
  },
  getters: {
    activeContentDIV: state => state.activeContentDIV
  }
})
